/**
 * Diskriminanten für den Business-Error-Screen.
 *
 * Diese Reasons sind fachliche Gründe (kein Crypto, kein Netzwerk), bei denen
 * die App den Patient:innen sagen muss: „Wir konnten die Absage nicht
 * entgegennehmen, bitte telefonisch klären." Vier Klassen:
 *
 * - `TOKEN_EXPIRED`: Einmal-Token ist abgelaufen.
 * - `TOKEN_ALREADY_USED`: Einmal-Token wurde bereits verwendet.
 * - `PRACTICE_REJECTED`: Praxis-Backend hat die Absage aus fachlichen Gründen abgelehnt.
 * - `TOO_LATE`: 24-Stunden-Sperre — Termin liegt zu nah, Absage nur noch telefonisch (DEV-014, Frontend-only).
 *
 * Bewusst als `as const`-Objekt + Type-Alias modelliert (keine `enum` —
 * TS-Guideline: kein `enum`). Eine „Termin nicht gefunden"-Variante existiert
 * bewusst nicht: dem Patient wird diese Information nie übermittelt, damit
 * unbekannte Token nicht durch Ausprobieren von existierenden unterschieden
 * werden können (das Praxis-Backend mappt diesen Fall serverseitig auf einen
 * generischen Fehler).
 */
export const BusinessErrorReason = {
  TokenExpired: 'TOKEN_EXPIRED',
  TokenAlreadyUsed: 'TOKEN_ALREADY_USED',
  PracticeRejected: 'PRACTICE_REJECTED',
  TooLate: 'TOO_LATE',
} as const;

export type BusinessErrorReason = (typeof BusinessErrorReason)[keyof typeof BusinessErrorReason];
